<template>
    <div id="app">
        <v-app>
            <v-card>
                
                <v-toolbar
                    color="#EEEEEE"
                    height="0px"
                >
                    <!-- <v-toolbar-title>David LUN</v-toolbar-title>
                    <v-spacer></v-spacer> -->
                    <!-- <img src="@/assets/banner.png"/> -->
                    <template v-slot:extension>
                        <v-tabs
                            v-model="tab"
                        >
                            <v-tabs-slider color="#1976D2"></v-tabs-slider>
        
                            <v-tab v-for="(n, i) in title.length" :key="i" :href="'#' + title[i].name">
                                {{ title[i].name.toUpperCase() }}
                                <v-icon> {{ title[i].icon }} </v-icon>
                            </v-tab>
                        </v-tabs>
                    </template>
                </v-toolbar>
      
                <v-tabs-items v-model="tab">
                    <v-tab-item v-for="(n, i) in title.length" :key="i" :value="title[i].name">
                        <Header :title="title[i].description"></Header>
                        <component :is="title[i].name"></component>
                        <Footer></Footer>
                    </v-tab-item>
                </v-tabs-items>
            </v-card>
        </v-app>
    </div>
</template>

<script>
import Header from './Header'
import Footer from './Footer'
import About from './About'
import Education from './Education'
import Skill from './Skill'

export default {
    components: {
        Header,
        Footer,
        About,
        Education,
        Skill,
    },
    name: "Menu",
    data: () => ({
        tab: "about",
        title: [
            {
                name: "about",
                icon: "mdi-badge-account-horizontal-outline",
                description: "About Me"
            },
            {
                name: "education",
                icon: "mdi-school-outline",
                description: "Education Qualification"
            },
            {
                name: "skill",
                icon: "mdi-laptop",
                description: "Skill Set"
            },

        ]
    }),
    created() {
        // console.log(this.title[0].name);
    }
}
</script>

<style scoped>
.navbar {
    position: sticky;
    position: -webkit-sticky; /* for Safari */
    top: 0;
    z-index: 3;
}
</style>
